import { render, staticRenderFns } from "./NgEditorCode.vue?vue&type=template&id=03ea28fb"
import script from "./NgEditorCode.vue?vue&type=script&lang=js"
export * from "./NgEditorCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports